import { IonRangeSliderEvent, IonRangeSliderOptions } from "ion-rangeslider";
import { RentalFilter } from "../RentalFilter";
import { RentalSelectionItem } from "../../../Models/Rental/RentalSelectionItem";
import { AxLoading } from "../../../Limestone/AxLoading/AxLoading";

export class RentalFilterPriceSlider {
    private priceRangeMin: number;
    private priceRangeMax: number;

    private lastPriceFilterTariff: number = 0;

    private rangeSlider: any;


    private _rentalFilterModule: RentalFilter;
    private _axLoading: AxLoading;

    constructor(rentalFilterModule: RentalFilter) {
        this._rentalFilterModule = rentalFilterModule;
        this._axLoading = new AxLoading();
    }


    setPriceFilter() {
        if (this._rentalFilterModule.rentalItemList == null) return;

        const filterListEmpty = this._rentalFilterModule.rentalItemList?.length > 0;
        let min = filterListEmpty ? this._rentalFilterModule.rentalItemList.reduce((prev, curr) => prev.price < curr.price ? prev : curr).price / 100 : 0;
        let max = filterListEmpty ? this._rentalFilterModule.rentalItemList.reduce((prev, curr) => prev.price > curr.price ? prev : curr).price / 100 : 0;

        if (min !== max) {
            if (this.rangeSlider != null) {
                this.rangeSlider.update({
                    min: min,
                    max: max,
                    from: min,
                    to: max
                });
                $('.retail__filter__price_holder').removeClass('d-none');
                return;
            }

            $("#retail__filter__price_slider").ionRangeSlider({
                skin: 'round',
                type: 'double',
                hide_min_max: true,
                extra_classes: 'ax-range-slider has-labels',
                prefix: `${this._rentalFilterModule.options.currencyString} `,
                max: max,
                min: min,
                drag_interval: true,
                onFinish: x => this.priceSliderChange(x),
                onUpdate: x => this.priceSliderChange(x),
                //onChange: x => this.backgroundUpdatePriceFilter(x)
            });
            this.rangeSlider = $("#retail__filter__price_slider").data("ionRangeSlider");

            $('.retail__filter__price_reset').click(x => {
                this.rangeSlider.update({
                    from: this.rangeSlider.options.min,
                    to: this.rangeSlider.options.max
                });
            });
            $('.retail__filter__price_holder').removeClass('d-none');
        } else {
            $('.retail__filter__price_holder').addClass('d-none');
        }
    }

    updateFilteredProducts(): void {
        //300ms loading
        this._axLoading.ShowLoadingIndicator($('.retail__filter_bar')[0], true);
        $('.retail__filter_bar--container').addClass('loading');
        this._rentalFilterModule.getFilterParameterAndUpdateCount();

        setTimeout(() => {
            let priceFilteredItems =
                this._rentalFilterModule.rentalItemList.filter(y => y.price > this.priceRangeMax || y.price < this.priceRangeMin);

            $('.rental__filter_item').removeClass('d-none');

            for (let item of priceFilteredItems) {
                $(`.rental__filter_item[data-itemid=${this.getIdentifier(item)}]`).addClass('d-none');
            }

            let entriesLeft: boolean = $('.rental__filter_item').not('.d-none').length !== 0;
            this._rentalFilterModule.printItemCount(this._rentalFilterModule.rentalItemList.length - priceFilteredItems.length);
            $('.retail__notFound').toggleClass('d-none', entriesLeft);

            this._axLoading.HideLoadingIndicator($('.retail__filter_bar')[0]);
            $('.retail__filter_bar--container').removeClass('loading');
        }, 300);
    }

    getIdentifier(item: RentalSelectionItem) {
        return `${item.type}_${item.productTriple.projNr}-${item.productTriple.productGroupIdentifier}-${item.productTriple.id}`;
    }

    priceSliderChange(event: IonRangeSliderEvent) {
        this.priceRangeMin = Math.round(event.from * 100);
        this.priceRangeMax = Math.round(event.to * 100);
        this.updateFilteredProducts();

        let priceFilteredItems = this.getPriceFilteredList(event);

        if (priceFilteredItems.length > 0) {
            let min = priceFilteredItems.reduce((prev, curr) => prev.price < curr.price ? prev : curr).price;
            let max = priceFilteredItems.reduce((prev, curr) => prev.price > curr.price ? prev : curr).price;

            if (min !== max) {
                this.updatePriceFilterSingleItem(0);
            }
        }
    }

    backgroundUpdatePriceFilter(event: IonRangeSliderEvent) {
        let priceFilteredItems = this.getPriceFilteredList(event);

        if (priceFilteredItems.length > 0) {
            let min = priceFilteredItems.reduce((prev, curr) => prev.price < curr.price ? prev : curr).price;
            let max = priceFilteredItems.reduce((prev, curr) => prev.price > curr.price ? prev : curr).price;

            if (min === max) {
                this.updatePriceFilterSingleItem(priceFilteredItems[0].price);
            }
        }
    }

    getPriceFilteredList(event: IonRangeSliderEvent) {
        return this._rentalFilterModule.rentalItemList.filter(y => y.price <= Math.round(event.to * 100) &&
            y.price >= Math.round(event.from * 100));
    }

    updatePriceFilterSingleItem(tariff: number) {
        if (tariff !== this.lastPriceFilterTariff) {
            this.lastPriceFilterTariff = tariff;
            if (tariff !== 0) {
                this.rangeSlider.update({
                    from_max: tariff / 100,
                    to_min: tariff / 100
                });
            } else {
                this.rangeSlider.update({
                    from_max: null,
                    to_min: null
                });
            }
        }
    }
}